import Dropdown from "react-bootstrap/Dropdown";
import { useLocation } from "react-router-dom";

import {
  EmailButton,
  EmailParams,
  FacebookButton,
  FacebookParams,
  LinkedinButton,
  LinkedinParams,
  TwitterButton,
  TwitterParams,
} from "@skv/core";

import { SvgSprite } from "@skv/core";
import { useAppSettings } from "@skv/state";

interface ShareSocialProps {
  showEmail?: boolean;
  showFacebook?: boolean;
  showLinkedin?: boolean;
  showTwitter?: boolean;
  emailOptions?: EmailParams;
  linkedinOptions?: LinkedinParams;
  facebookOptions?: FacebookParams;
  twitterOptions?: TwitterParams;
}

export const ShareSocialInline = ({
  showEmail,
  emailOptions,
  showFacebook,
  facebookOptions,
  showLinkedin,
  linkedinOptions,
  showTwitter,
  twitterOptions,
}: ShareSocialProps) => {
  const { pathname } = useLocation();
  const { applicationName, applicationUrl, facebookAppId } = useAppSettings();
  const shareBtnCss = `
    padding: 0.25rem;
    &:hover {
      background-color: #f4f6fe;
    }
  `;
  return (
    <div className="d-flex flex-wrap gap-1 ml-n1">
      {showFacebook && (
        <FacebookButton
          css={shareBtnCss}
          params={Object.assign(
            {
              app_id: facebookAppId,
              display: "page",
              redirect_uri: `${applicationUrl}${pathname}`,
              href: `${applicationUrl}${pathname}`,
            },
            facebookOptions
          )}
        >
          <SvgSprite
            id="icons:facebook-circle"
            width={32}
            height={32}
            aria-label="Facebook"
          />
        </FacebookButton>
      )}
      {showTwitter && (
        <TwitterButton
          css={shareBtnCss}
          params={Object.assign(
            {
              url: `${applicationUrl}${pathname}`,
              text: `I saw this on ${applicationName} and wanted to share it:\n\n`,
            },
            twitterOptions
          )}
        >
          <SvgSprite
            id="icons:twitter-circle"
            width={32}
            height={32}
            aria-label="Twitter"
          />
        </TwitterButton>
      )}
      {showLinkedin && (
        <LinkedinButton
          css={shareBtnCss}
          params={Object.assign(
            {
              url: `${applicationUrl}${pathname}`,
            },
            linkedinOptions
          )}
        >
          <SvgSprite
            id="icons:linkedin-circle"
            width={32}
            height={32}
            aria-label="Linked-in"
          />
        </LinkedinButton>
      )}
      {showEmail && (
        <EmailButton
          css={shareBtnCss}
          params={Object.assign(
            {
              subject: `Sharing from ${applicationName}`,
              separator: "\n\n",
              body: `I saw this on ${applicationName} and wanted to share with you:\n\n${applicationUrl}${pathname}\n\n`,
            },
            emailOptions
          )}
        >
          <SvgSprite
            id="icons:envelope-outline"
            width={32}
            height={32}
            aria-label="Email a friend"
          />
        </EmailButton>
      )}
    </div>
  );
};

export const ShareSocialDropdown = ({
  showEmail,
  emailOptions,
  showFacebook,
  facebookOptions,
  showLinkedin,
  linkedinOptions,
  showTwitter,
  twitterOptions,
}: ShareSocialProps) => {
  const { pathname } = useLocation();
  const { applicationName, applicationUrl, facebookAppId } = useAppSettings();
  const shareBtnCss = `
    width: 100%;
    text-align: left;
    padding: 0.25rem 0.5rem;
    transition: all 100ms ease;

    &:hover {
      background-color: #F2F2F2;
    }
  `;

  return (
    <Dropdown>
      <Dropdown.Toggle
        id="social-share-dropdown"
        variant=""
        aria-label="Share"
        className="btn btn-link d-flex align-items-center"
        css={`
          &:hover {
            text-decoration: unset;
            background-color: #f2f2f2;
          }
          &:focus {
            text-decoration: unset;
          }
          &::after {
            content: unset !important;
          }
        `}
      >
        <i className="material-icons text-primary fs-6 ml-n1" aria-hidden>
          share
        </i>
        <strong className="text-primary fs-6 ml-2" aria-hidden>
          Share
        </strong>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="d-flex flex-column gap-1"
        css={`
          min-width: unset !important;
        `}
      >
        {showEmail && (
          <EmailButton
            css={shareBtnCss}
            params={Object.assign(
              {
                subject: `Sharing from ${applicationName}`,
                separator: "\n\n",
                body: `I saw this on ${applicationName} and wanted to share with you:\n\n${applicationUrl}${pathname}\n\n`,
              },
              emailOptions
            )}
          >
            Email&nbsp;a&nbsp;friend
          </EmailButton>
        )}
        {showFacebook && (
          <FacebookButton
            css={shareBtnCss}
            params={Object.assign(
              {
                app_id: facebookAppId,
                display: "page",
                redirect_uri: `${applicationUrl}${pathname}`,
                href: `${applicationUrl}${pathname}`,
              },
              facebookOptions
            )}
          >
            Facebook
          </FacebookButton>
        )}
        {showTwitter && (
          <TwitterButton
            css={shareBtnCss}
            params={Object.assign(
              {
                url: `${applicationUrl}${pathname}`,
                text: `I saw this on ${applicationName} and wanted to share it:\n\n`,
              },
              twitterOptions
            )}
          >
            Twitter
          </TwitterButton>
        )}
        {showLinkedin && (
          <LinkedinButton
            css={shareBtnCss}
            params={Object.assign(
              {
                url: `${applicationUrl}${pathname}`,
              },
              linkedinOptions
            )}
          >
            LinkedIn
          </LinkedinButton>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};
